// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSciencePlantSeedling = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.718 8h.706c-.186-.679-.467-1.251-.811-1.698C9.006 5.515 8.12 5 6.838 5H5.112c.257 1.148.734 1.771 1.228 2.15.719.55 1.823.85 3.378.85zm7.07-3h2.522c.53 0 .966.45.922 1-.342 4.274-2.906 6-6.026 6h-1.608v1.063a7.43 7.43 0 0 1 1.98.546 7.668 7.668 0 0 1 2.49 1.734 8.03 8.03 0 0 1 1.665 2.595c.264.662.44 1.357.525 2.065a.895.895 0 0 1-.9.997H4.918a.895.895 0 0 1-.9-.997 8.267 8.267 0 0 1 .525-2.064 8.03 8.03 0 0 1 1.665-2.596 7.667 7.667 0 0 1 2.491-1.734 7.436 7.436 0 0 1 1.98-.546V10h-.96c-3.477 0-6.337-1.304-6.685-6-.04-.551.394-1 .924-1h2.88c2.804 0 4.659 1.789 5.398 4.33C13.355 5.9 14.98 5 16.787 5zm-3.846 5h1.264c1.232 0 2.164-.339 2.8-.911.461-.414.89-1.062 1.135-2.089h-1.354c-1.616 0-3.174 1.166-3.845 3zm-1.304 5c-.756 0-1.505.155-2.204.457a5.751 5.751 0 0 0-1.869 1.3A6.021 6.021 0 0 0 6.208 19h10.86a6.023 6.023 0 0 0-1.358-2.243c-.534-.557-1.169-.999-1.868-1.3A5.56 5.56 0 0 0 11.638 15z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSciencePlantSeedling;
